// Error code → German user-facing message
const CODE_MESSAGES = {
	// Auth
	UNAUTHORIZED: 'Sie haben keine Berechtigung für diese Aktion.',
	AUTH_UNAVAILABLE: 'Die Anmeldung ist vorübergehend nicht verfügbar. Bitte versuchen Sie es gleich noch einmal.',

	// Billing
	NO_ACTIVE_SUBSCRIPTION: 'Kein aktives Abonnement gefunden.',
	NO_BILLING_CUSTOMER: 'Kein Billing-Konto gefunden.',
	PLAN_UPGRADE_REQUIRED: 'Für diese Aktion ist ein kostenpflichtiger Plan erforderlich.',
	STRIPE_CUSTOMER_NOT_FOUND: 'Es gab ein Problem mit Ihrem Zahlungskonto. Bitte kontaktieren Sie den Support.',
	ADDON_ALREADY_ACTIVE: 'Das Add-on ist bereits aktiv.',
	NO_SUBSCRIPTION_FOR_ADDON:
		'Für das CRM-Add-on ist ein aktives Abonnement erforderlich. Bitte wählen Sie zuerst einen Plan.',
	NO_ACTIVE_ADDON: 'Kein aktives Add-on gefunden.',

	// Credits
	INSUFFICIENT_COMPANY_CREDITS: 'Nicht genügend Firmen-Credits für diese Aktion.',
	INSUFFICIENT_CONTACT_CREDITS: 'Nicht genügend Kontakt-Credits für diese Aktion.',
	INSUFFICIENT_CREDITS: 'Nicht genügend Credits für diese Aktion.',
	INVALID_CREDIT_TYPE: 'Ungültiger Credit-Typ.',
	WALLET_NOT_FOUND: 'Kein Guthaben-Konto gefunden.',

	// Email
	EMAIL_ACCOUNT_EXISTS: 'Ein E-Mail-Konto mit dieser Adresse existiert bereits.',
	EMAIL_ACCOUNT_NOT_FOUND: 'E-Mail-Konto nicht gefunden.',
	EMAIL_OAUTH_ONLY: 'Nur OAuth-Konten können erneut autorisiert werden.',
	EMAIL_CAMPAIGN_NOT_FOUND: 'Kampagne nicht gefunden.',
	EMAIL_CAMPAIGN_NOT_ACTIVE: 'Die Kampagne muss aktiv sein, um fehlgeschlagene E-Mails erneut zu versenden.',
	EMAIL_CAMPAIGN_FORBIDDEN: 'Sie haben keine Berechtigung für diese Kampagne.',
	EMAIL_GENERATED_NOT_FOUND: 'Generierte E-Mail nicht gefunden.',
	EMAIL_GENERATED_NOT_APPROVED: 'Diese E-Mail ist nicht genehmigt und kann nicht zurückgezogen werden.',
	EMAIL_GENERATED_ALREADY_SENT: 'Diese E-Mail wurde bereits versendet und kann nicht mehr zurückgezogen werden.',
	EMAIL_CAMPAIGN_MAIL_NOT_FOUND: 'Kampagnen-E-Mail nicht gefunden.',
	EMAIL_NO_GENERATION_IN_PROGRESS: 'Es läuft keine Generierung, die abgebrochen werden kann.',
	EMAIL_NO_JOB_FOR_GENERATION: 'Kein Auftrag für diese Generierung gefunden.',
	EMAIL_OAUTH_TOKEN_EXPIRED: 'Das OAuth-Token ist abgelaufen. Bitte verbinden Sie Ihr Konto erneut.',
	EMAIL_SMTP_CONNECTION_FAILED:
		'Die SMTP-Verbindung konnte nicht hergestellt werden. Bitte überprüfen Sie Ihre Zugangsdaten.',
	EMAIL_OAUTH_CONNECTION_FAILED:
		'Die OAuth-Verbindung konnte nicht hergestellt werden. Bitte verbinden Sie Ihr Konto erneut.',
	EMAIL_UNSUPPORTED_PROVIDER: 'Dieser E-Mail-Anbieter wird nicht unterstützt.',

	// Jobs
	JOB_NOT_FOUND: 'Auftrag nicht gefunden.',
	JOB_UNAUTHORIZED: 'Sie haben keine Berechtigung für diesen Auftrag.',
	JOB_INVALID_TYPE: 'Ungültiger Auftragstyp.',
	JOB_ALREADY_FINISHED: 'Der Auftrag wurde bereits abgeschlossen.',
	JOB_ALREADY_RUNNING: 'Für diese Suche läuft bereits ein Auftrag. Bitte warten Sie, bis er abgeschlossen ist.',

	// Org / Members
	ALREADY_MEMBER: 'Dieser Benutzer ist bereits Mitglied der Organisation.',
	CANNOT_CHANGE_OWN_ROLE: 'Sie können Ihre eigene Rolle nicht ändern.',
	CANNOT_REMOVE_OWNER: 'Der Eigentümer der Organisation kann nicht entfernt werden.',
	CANNOT_SELF_TRANSFER: 'Sie können keine Credits an sich selbst übertragen.',
	INVALID_ROLE: 'Die angegebene Rolle ist ungültig.',
	INVITE_EXPIRED: 'Diese Einladung ist abgelaufen.',
	INVITE_NOT_FOUND: 'Einladung nicht gefunden.',
	INVITE_WRONG_ACCOUNT: 'Diese Einladung gehört nicht zu Ihrem Konto.',
	ORG_NOT_FOUND: 'Organisation nicht gefunden.',
	PENDING_INVITE_EXISTS: 'Für diesen Benutzer existiert bereits eine ausstehende Einladung.',
	USER_HAS_ORG: 'Dieser Benutzer gehört bereits zu einer anderen Organisation.',
	SEATS_EXHAUSTED: 'Alle Plätze sind belegt. Bitte upgraden Sie Ihren Plan.',
	TRANSFER_FAILED: 'Die Übertragung ist fehlgeschlagen.',
	WRONG_ORG: 'Sender und Empfänger müssen zur selben Organisation gehören.',

	// Prospect Queries
	QUERY_NOT_FOUND: 'Die Suchliste wurde nicht gefunden.',
	QUERY_FORBIDDEN: 'Diese Suchliste wurde nur zum Lesen mit Ihnen geteilt.',
	SOURCE_QUERY_FORBIDDEN: 'Sie haben keine Berechtigung für die Quell-Liste.',
	SOURCE_QUERY_NOT_FOUND: 'Die Quell-Liste wurde nicht gefunden.',
	TARGET_QUERY_FORBIDDEN: 'Sie haben keine Berechtigung für die Ziel-Liste.',
	TARGET_QUERY_NOT_FOUND: 'Die Ziel-Liste wurde nicht gefunden.',

	// Search
	SEARCH_UNSUPPORTED_TYPE: 'Nicht unterstützter Suchtyp.',
	SEARCH_QUERY_NOT_FOUND: 'Suchanfrage nicht gefunden oder keine Berechtigung.',
	SEARCH_QUERY_UNAUTHORIZED: 'Sie haben keine Berechtigung für diese Suchanfrage.',
	SEARCH_INVALID_PARAMS: 'Ungültige Suchparameter. Bitte überprüfen Sie Ihre Eingaben.',
	SEARCH_POSTAL_RANGE_EMPTY: 'Im angegebenen PLZ-Bereich existieren keine gültigen Postleitzahlen.',
	SEARCH_POSTAL_TOO_MANY:
		'Der PLZ-Filter umfasst zu viele Postleitzahlen für die Karten-Suche (max. 30). Bitte grenzen Sie den Bereich weiter ein.',
	SEARCH_COMPANY_NOT_FOUND: 'Das Unternehmen wurde nicht gefunden.',
	SEARCH_EXCLUDE_QUERY_NOT_FOUND:
		'Eine der auszuschließenden Suchen wurde nicht gefunden oder gehört nicht zu Ihrer Organisation.',
	SEARCH_EXCLUDE_CONTACT_LIST_NOT_FOUND:
		'Eine der auszuschließenden Kontaktlisten wurde nicht gefunden oder gehört nicht zu Ihrer Organisation.',

	// Leads
	LEADS_NOT_FOUND: 'Lead nicht gefunden.',
	LEADS_EXPORT_NOT_FOUND: 'Export-Liste nicht gefunden oder keine Berechtigung.',
	LEADS_EXPORT_FORBIDDEN: 'Sie haben keine Berechtigung für diesen Export.',
	LEADS_ANALYSIS_IN_PROGRESS:
		'Für diese Suche läuft bereits eine KI-Analyse. Bitte warten Sie, bis sie abgeschlossen ist.',
	LEADS_COMPANIES_FORBIDDEN: 'Sie haben keine Berechtigung für diese Firmen.',

	// CSV Import
	CSV_IMPORT_LIMIT_EXCEEDED: 'Maximal 2.000 Firmen pro Import erlaubt. Bitte teilen Sie die Datei auf.',
	MISSING_COMPANY_NAME: 'Firmenname fehlt',
	MISSING_WEBSITE_URL: 'Website / Domain fehlt',
	INVALID_WEBSITE_URL: 'Ungültige Website-URL',
	PROCESSING_ERROR: 'Fehler bei der Verarbeitung',

	// System
	INTERNAL_ERROR: 'Ein interner Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
	REQUEST_TOO_LARGE: 'Die Anfrage ist zu groß. Bitte reduzieren Sie die Datenmenge.',
	VALIDATION_ERROR: 'Die Eingabe enthält ungültige Werte. Bitte überprüfen Sie die markierten Felder.',
	VALIDATION_REQUIRED_FIELD: 'Ein Pflichtfeld fehlt. Bitte überprüfen Sie Ihre Eingabe.',
	BULK_SCOPE_EMPTY: 'Die Auswahl enthält keine Einträge. Bitte passen Sie Auswahl oder Filter an.',

	// Billing (new)
	BILLING_MISSING_WEBHOOK_SIGNATURE: 'Ungültige Webhook-Signatur.',
	BILLING_MULTIPLE_SUBSCRIPTIONS: 'Mehrere aktive Abonnements gefunden. Bitte kontaktieren Sie den Support.',
	BILLING_SEATS_NOT_FOUND: 'Platzinformationen nicht gefunden.',
	BILLING_DOWNGRADE_PENDING:
		'Für Ihr Abonnement ist bereits ein Tarifwechsel zum Periodenende geplant. Bitte heben Sie diesen zuerst auf.',
	BILLING_NO_PENDING_DOWNGRADE: 'Es ist kein Tarifwechsel geplant, der aufgehoben werden könnte.',
	BILLING_ALREADY_CANCELLING: 'Ihr Abonnement ist bereits zum Ende der Abrechnungsperiode gekündigt.',
	BILLING_NOT_CANCELLING: 'Für Ihr Abonnement liegt keine Kündigung vor, die zurückgenommen werden könnte.',
	BILLING_ALREADY_PAUSED: 'Ihr Abonnement ist bereits pausiert.',
	BILLING_NOT_PAUSED: 'Ihr Abonnement ist nicht pausiert.',
	BILLING_PAUSE_NOT_ELIGIBLE: 'Eine Pause ist für Ihr Abonnement derzeit nicht möglich.',
	BILLING_SUBSCRIPTION_PAUSED:
		'Während einer Pause sind keine Tarif- oder Add-on-Änderungen möglich. Setzen Sie Ihr Abonnement zuerst fort.',
	BILLING_SUBSCRIPTION_EXISTS:
		'Für Ihre Organisation läuft bereits ein Abonnement. Wechseln Sie den Tarif, statt ein zweites abzuschließen.',
	BILLING_PRICE_NOT_FOUND: 'Dieser Tarif ist nicht mehr verfügbar. Bitte laden Sie die Seite neu.',
	BILLING_PLAN_UNCHANGED: 'Sie nutzen diesen Tarif bereits.',
	BILLING_PAYMENT_DECLINED:
		'Ihre Zahlungsmethode wurde abgelehnt. Bitte hinterlegen Sie eine andere Karte oder kontaktieren Sie Ihre Bank.',
	BILLING_RATE_LIMITED:
		'Zu viele Anfragen an unseren Zahlungsanbieter. Bitte versuchen Sie es in einem Moment erneut.',
	BILLING_PROVIDER_ERROR:
		'Unser Zahlungsanbieter ist derzeit nicht erreichbar. Bitte versuchen Sie es später erneut.',
	BILLING_INVALID_WEBHOOK_SIGNATURE: 'Ungültige Webhook-Signatur.',

	// Email (new)
	EMAIL_SIGNATURE_NOT_FOUND: 'Signatur nicht gefunden.',
	EMAIL_TEMPLATE_NOT_FOUND: 'E-Mail-Vorlage nicht gefunden.',
	EMAIL_TEMPLATE_ATTACHMENT_TOO_LARGE: 'Die Datei ist zu groß (max. 2 MB).',
	EMAIL_TEMPLATE_ATTACHMENT_INVALID_TYPE:
		'Ungültiges Dateiformat. Erlaubt sind PDF, JPG, PNG, WebP, DOCX, XLSX oder PPTX.',
	EMAIL_TEMPLATE_ATTACHMENT_NOT_FOUND: 'Der Anhang wurde nicht gefunden.',
	EMAIL_TONE_NOT_FOUND: 'Tonalität nicht gefunden oder kann nicht bearbeitet werden.',
	EMAIL_CAMPAIGN_STEP_NOT_FOUND: 'Kampagnen-Schritt nicht gefunden.',

	// Leads (new)
	LEADS_CONTACT_NOT_FOUND: 'Kontakt nicht gefunden.',
	LEADS_COMPANY_NOT_FOUND: 'Unternehmen nicht gefunden.',
	LEADS_COMPANY_POSITION_NOT_FOUND: 'Die Firma wurde in dieser Lead-Liste nicht gefunden.',

	// Search (new)
	SEARCH_CONTENT_REQUIRED: 'Bitte geben Sie eine Nachricht ein.',
	SEARCH_LOOKALIKE_SEED_MISSING: 'Für mindestens eine Beispielfirma liegt noch kein Website-Profil vor.',
	SEARCH_TARGETING_DISABLED:
		'Die Suche nach Website-Merkmalen ist derzeit nicht verfügbar. Bitte entfernen Sie Zielgruppen- und Geschäftsführungs-Kriterien.',

	// Postmailing (new)
	POSTMAILING_CAMPAIGN_NOT_FOUND: 'Die Kampagne wurde nicht gefunden.',
	POSTMAILING_CAMPAIGN_NOT_DRAFT: 'Diese Kampagne kann nicht mehr bearbeitet werden, da sie kein Entwurf mehr ist.',
	POSTMAILING_NO_RECIPIENTS:
		'Diese Kampagne hat keine Empfänger. Bitte wählen Sie mindestens eine Empfängerliste aus.',
	POSTMAILING_MISSING_ADDRESSES: 'Für einige Empfänger fehlt eine gültige Postanschrift.',
	POSTMAILING_CONTACT_NO_COMPANY:
		'Dieser Kontakt ist keinem Unternehmen zugeordnet. Für den Briefversand wird eine Unternehmensadresse benötigt.',
	POSTMAILING_ADDRESS_INCOMPLETE:
		'Die Adresse des Unternehmens ist unvollständig. Bitte ergänzen Sie Straße, PLZ und Ort.',
	POSTMAILING_SEND_FAILED: 'Der Versand konnte nicht gestartet werden. Bitte versuchen Sie es erneut.',
	POSTMAILING_BILLING_FAILED:
		'Die Abrechnung konnte nicht durchgeführt werden. Bitte überprüfen Sie Ihre Zahlungsdaten.',
	POSTMAILING_CHECKOUT_FAILED: 'Die Zahlung konnte nicht gestartet werden. Bitte versuchen Sie es erneut.',
	POSTMAILING_NO_ACTIVE_SUBSCRIPTION: 'Für den Briefversand ist ein aktives Abonnement erforderlich.',
	POSTMAILING_TEMPLATE_NOT_FOUND: 'Brief-Vorlage nicht gefunden.',
	POSTMAILING_NOTHING_TO_CONFIRM: 'Keine Briefe zum Bestätigen oder Überspringen ausgewählt.',
	POSTMAILING_CANCEL_NOT_ALLOWED: 'Diese Kampagne kann nicht mehr storniert werden.',
	POSTMAILING_CANCEL_TOO_LATE: 'Der Versand läuft bereits und kann nicht mehr storniert werden.',
	POSTMAILING_NOT_SENT: 'Diese Kampagne wurde noch nicht an den Briefversand übermittelt.',
	POSTMAILING_EBRIEF_API_ERROR:
		'Der Briefversand-Dienst ist derzeit nicht erreichbar. Bitte versuchen Sie es später erneut.',
	POSTMAILING_MISSING_DESIGN: 'Für diese Vorlage liegen keine Designdaten vor.',
	POSTMAILING_PDF_GENERATION_FAILED: 'Die PDF-Vorschau konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
	POSTMAILING_SEND_NOT_FOUND: 'Der Versandeintrag wurde nicht gefunden.',
	POSTMAILING_PDF_NOT_AVAILABLE: 'Für diesen Versand ist kein PDF verfügbar.',
	POSTMAILING_PDF_STORAGE_ERROR: 'Das PDF konnte nicht geladen werden. Bitte versuchen Sie es später erneut.',
	POSTMAILING_MEDIA_NOT_FOUND: 'Das Bild wurde nicht gefunden.',
	POSTMAILING_MEDIA_INVALID_TYPE: 'Ungültiges Bildformat. Erlaubt sind JPG, PNG oder WebP.',
	POSTMAILING_MEDIA_TOO_LARGE: 'Das Bild ist zu groß (max. 5 MB).',
	POSTMAILING_PDF_INVALID: 'Die Datei ist kein gültiges PDF.',
	POSTMAILING_PDF_ENCRYPTED: 'Das PDF ist passwortgeschützt. Bitte laden Sie eine ungeschützte Version hoch.',
	POSTMAILING_PDF_PAGE_COUNT: 'Das PDF muss genau eine Seite haben.',
	POSTMAILING_PDF_NOT_A4: 'Das PDF muss DIN A4 im Hochformat sein (210 × 297 mm).',
	POSTMAILING_PDF_TOO_LARGE: 'Das PDF ist zu groß (max. 10 MB).',
	POSTMAILING_PDF_TEMPLATE_INCOMPLETE: 'Bitte laden Sie zuerst die Vorderseite hoch.',
	POSTMAILING_PDF_PREVIEW_UNAVAILABLE:
		'Für dieses Sonderformat ist keine Adress-Vorschau verfügbar. Wir versenden es individuell.',

	// Contact Lists
	CONTACT_LIST_NOT_FOUND: 'Kontaktliste nicht gefunden.',
	CONTACT_LIST_RECIPIENT_NOT_FOUND: 'Der Eintrag ist nicht (mehr) in dieser Kontaktliste.',

	// Contact Blacklist
	CONTACT_BLACKLIST_ENTRY_NOT_FOUND: 'Der Blacklist-Eintrag wurde nicht gefunden.',
	CONTACT_BLACKLIST_DUPLICATE_ENTRY: 'Dieser Eintrag steht bereits auf der Blacklist.',
	CONTACT_BLACKLIST_INVALID_VALUE: 'Bitte geben Sie eine gültige E-Mail-Adresse bzw. Domain ein.',
	CONTACT_BLACKLIST_FREEMAIL_DOMAIN:
		'Freemail-Domains wie gmail.com oder web.de können nicht auf die Blacklist gesetzt werden. Setzen Sie stattdessen die einzelne E-Mail-Adresse auf die Blacklist.',
	CONTACT_BLACKLIST_RECIPIENT_BLOCKED:
		'Dieser Empfänger steht auf der Blacklist und kann nicht angeschrieben werden.',

	// Events
	EVENTS_INVALID_TOPIC: 'Ungültiges Topic-Format.',
	EVENTS_NOT_AUTHORIZED: 'Keine Berechtigung für diese Ressource.',

	// Org (new)
	MISSING_CAPABILITY: 'Diese Aktion ist in Ihrem aktuellen Abo nicht verfügbar.',
	USER_NOT_FOUND: 'Benutzer nicht gefunden.',
	CLIENT_NOT_FOUND: 'Mandant nicht gefunden.',
	COMPANY_PROFILE_UPDATE_FAILED: 'Die Firmendaten konnten nicht gespeichert werden.',

	// CRM: Deals
	CRM_DEAL_NOT_FOUND: 'Der Deal wurde nicht gefunden.',
	CRM_DEAL_NOT_IN_TRASH: 'Der Deal wurde nicht im Papierkorb gefunden.',
	CRM_DEAL_RESTORE_COMPANY_TRASHED:
		'Der Deal kann nicht wiederhergestellt werden, solange das Unternehmen im Papierkorb liegt. Bitte stellen Sie zuerst das Unternehmen wieder her.',
	CRM_DEAL_STAGE_MISMATCH: 'Die Phase gehört nicht zu dieser Pipeline oder Organisation.',
	CRM_DEAL_CROSS_PIPELINE_MOVE:
		'Ein Deal kann nicht über Phasen-Wechsel in eine andere Pipeline verschoben werden. Nutzen Sie die Pipeline-Verschiebung.',
	CRM_DEAL_DELETE_FORBIDDEN: 'Nur Admins und Eigentümer können Deals löschen.',
	CRM_DEAL_RESTORE_FORBIDDEN: 'Nur Admins und Eigentümer können Deals wiederherstellen.',
	CRM_DEAL_RESTORE_PIPELINE_TRASHED:
		'Der Deal kann nicht wiederhergestellt werden, solange seine Pipeline im Papierkorb liegt. Bitte stellen Sie zuerst die Pipeline wieder her.',
	CRM_DEAL_LOSS_REASON_INVALID:
		'Der gewählte Verlustgrund ist nicht (mehr) verfügbar. Bitte wählen Sie einen Grund aus der Liste.',
	CRM_DEAL_LOSS_REASON_REQUIRED: 'Bitte geben Sie einen Verlustgrund an.',

	// CRM: Pipelines & Stages
	CRM_PIPELINE_NOT_FOUND: 'Die Pipeline wurde nicht gefunden.',
	CRM_PIPELINE_HAS_DEALS: 'Die Pipeline enthält noch Deals. Bitte verschieben oder löschen Sie diese zuerst.',
	CRM_PIPELINE_NOT_IN_TRASH: 'Die Pipeline wurde nicht im Papierkorb gefunden.',
	CRM_PIPELINE_DELETE_FORBIDDEN: 'Nur Admins und Eigentümer können Pipelines löschen.',
	CRM_PIPELINE_RESTORE_FORBIDDEN: 'Nur Admins und Eigentümer können Pipelines wiederherstellen.',
	CRM_STAGE_NOT_FOUND: 'Die Phase wurde nicht gefunden.',
	CRM_STAGE_HAS_DEALS: 'Die Phase enthält noch Deals. Bitte verschieben Sie diese zuerst.',
	CRM_STAGE_WRONG_ORG: 'Die Zielphase gehört zu einer anderen Organisation.',
	CRM_STAGE_PIPELINE_MISMATCH: 'Die Phase gehört nicht zu der angegebenen Pipeline.',
	CRM_STAGE_ORDER_CONFLICT: 'Eine andere Phase wurde gerade gleichzeitig erstellt. Bitte erneut versuchen.',

	// CRM: Companies
	CRM_COMPANY_NOT_FOUND: 'Das Unternehmen wurde nicht gefunden.',
	CRM_COMPANY_NOT_IN_TRASH: 'Das Unternehmen wurde nicht im Papierkorb gefunden.',
	CRM_COMPANY_DELETE_FORBIDDEN: 'Nur Admins und Eigentümer können Unternehmen löschen.',
	CRM_COMPANY_RESTORE_FORBIDDEN: 'Nur Admins und Eigentümer können Unternehmen wiederherstellen.',

	// CRM: Tags
	CRM_TAG_NOT_FOUND: 'Das Tag wurde nicht gefunden.',
	CRM_TAG_NAME_DUPLICATE: 'Ein Tag mit diesem Namen existiert bereits.',

	// CRM: Contacts
	CRM_CONTACT_NOT_FOUND: 'Der Kontakt wurde nicht gefunden.',
	CRM_CONTACT_NOT_IN_TRASH: 'Der Kontakt wurde nicht im Papierkorb gefunden.',
	CRM_CONTACT_RESTORE_COMPANY_TRASHED:
		'Der Kontakt kann nicht wiederhergestellt werden, solange das Unternehmen im Papierkorb liegt. Bitte stellen Sie zuerst das Unternehmen wieder her.',
	CRM_CONTACT_COMPANY_NOT_FOUND: 'Das zugehörige Unternehmen wurde nicht gefunden.',

	// CRM: Activities
	CRM_ACTIVITY_NOT_FOUND: 'Die Aktivität wurde nicht gefunden.',
	CRM_ACTIVITY_SYSTEM_IMMUTABLE: 'Systemaktivitäten können nicht gelöscht werden.',
	CRM_ACTIVITY_AUTOMATED: 'Diese Aktivität wird automatisch ausgeführt und kann nicht manuell abgeschlossen werden.',
	CRM_ACTIVITY_NO_EMAIL_SEND: 'Zu dieser Aktivität existiert keine geplante E-Mail.',
	CRM_ACTIVITY_SEND_NOT_EDITABLE: 'Die E-Mail wurde bereits versendet und kann nicht mehr bearbeitet werden.',

	// Custom Columns
	CUSTOM_COLUMN_NOT_FOUND: 'Die Spalte wurde nicht gefunden.',
	CUSTOM_COLUMN_KEY_TAKEN:
		'Für diesen Spaltennamen ist keine Variable mehr frei. Bitte wählen Sie einen anderen Namen.',
	CUSTOM_COLUMN_TEMPLATE_INVALID: 'Die Zusammensetzung enthält unbekannte Felder oder offene Klammern.',
	CUSTOM_COLUMN_IN_USE:
		'Die Spalte wird noch in einer E-Mail-Vorlage, Briefvorlage oder offenen Brief-Kampagne verwendet und kann nicht gelöscht werden.',
	CUSTOM_COLUMN_NOT_AI: 'Nur KI-Spalten können befüllt oder von Hand bearbeitet werden.',
	CUSTOM_COLUMN_FILL_IN_PROGRESS:
		'Diese Spalte wird gerade befüllt. Bitte warten Sie, bis der Lauf abgeschlossen ist.',
	CUSTOM_COLUMN_FILL_TOO_LARGE:
		'Pro Lauf können höchstens 2.000 Zeilen befüllt werden. Bitte wählen Sie weniger Zeilen aus.',
	CUSTOM_COLUMN_VALUE_MISSING:
		'Für diesen Empfänger fehlt der Wert einer eigenen Spalte. Bitte Wert eintragen oder einen Ersatzwert festlegen.',
	CUSTOM_COLUMN_RATE_LIMITED: 'Zu viele Läufe in kurzer Zeit. Bitte versuchen Sie es später erneut.',

	// CRM: Custom Fields
	CRM_FIELD_NOT_FOUND: 'Das Feld wurde nicht gefunden.',
	CRM_FIELD_DEFAULT_CREATE_BLOCKED: 'Standard-Felder können nicht über die API erstellt werden.',
	CRM_FIELD_KEY_RESERVED: 'Der Feldschlüssel ist für Standard-Felder reserviert.',
	CRM_FIELD_NAME_DUPLICATE: 'Ein Feld mit diesem Namen existiert bereits für diesen Typ.',
	CRM_FIELD_DEFAULT_PROP_IMMUTABLE: 'Diese Eigenschaft kann bei Standard-Feldern nicht geändert werden.',
	CRM_FIELD_SELECT_ONLY: 'Auswahloptionen können nur bei Dropdown-Feldern geändert werden.',
	CRM_FIELD_DEFAULT_DELETE_BLOCKED:
		'Standard-Felder können nicht gelöscht werden. Verwenden Sie die Sichtbarkeit zum Ausblenden.',
	CRM_FIELD_IDS_UNKNOWN: 'Unbekannte Feld-IDs wurden angegeben.',

	// CRM: Validation
	CRM_REQUIRED_FIELDS_MISSING: 'Pflichtfeld(er) fehlen. Bitte füllen Sie alle erforderlichen Felder aus.',
	CRM_CUSTOM_FIELD_UNKNOWN: 'Unbekannte benutzerdefinierte Felder wurden angegeben.',
	CRM_CUSTOM_FIELD_INVALID_TYPE: 'Ein benutzerdefiniertes Feld hat einen ungültigen Wert.',
	CRM_CUSTOM_FIELD_INVALID_OPTION: 'Ein benutzerdefiniertes Feld enthält eine ungültige Auswahloption.',

	// CRM: Insights
	CRM_SUGGESTION_NOT_FOUND: 'Der Vorschlag wurde nicht gefunden.',
	CRM_SUGGESTION_ALREADY_HANDLED: 'Dieser Vorschlag wurde bereits bearbeitet.',
	CRM_SUGGESTION_NO_REFERENCE: 'Der Vorschlag hat keinen Deal- oder Unternehmensbezug.',

	// CRM: Pipeline AI Generator
	CRM_GENERATION_NOT_FOUND: 'Die Generierung wurde nicht gefunden.',
	CRM_ANALYSIS_NOT_COMPLETED:
		'Die Unternehmensanalyse muss abgeschlossen sein, bevor eine Pipeline generiert werden kann.',
	CRM_PIPELINE_ALREADY_GENERATED: 'Für diesen Eintrag wurde bereits eine Pipeline generiert.',

	// CRM: Integrations
	CRM_AIRCALL_NOT_CONNECTED:
		'Die Aircall-Integration ist nicht verbunden. Bitte verbinden Sie Aircall in den CRM-Einstellungen.',
	CRM_AIRCALL_USER_NOT_FOUND:
		'Kein Aircall-Benutzer zugeordnet. Bitten Sie einen Admin, die Zuordnung in den CRM-Einstellungen unter Integrationen vorzunehmen.',
	CRM_INTEGRATION_NOT_FOUND: 'Unbekannte Integration.',
	CRM_CHANNEL_TYPE_NOT_FOUND: 'Der Kanaltyp wurde nicht gefunden.',

	// CRM: Imports
	CRM_LEAD_NOT_FOUND: 'Der Lead wurde nicht gefunden.',
	CRM_IMPORT_LIMIT_EXCEEDED: 'Maximale Importgröße überschritten (max. 10.000 Zeilen).',
	CRM_IMPORT_INVALID_MAPPING: 'Die Spaltenzuordnung ist ungültig.',
	CRM_IMPORT_PIPELINE_REQUIRED: 'Bitte wählen Sie eine Pipeline für den Deal-Import.',
	CRM_IMPORT_JOB_NOT_FOUND: 'Import-Job nicht gefunden.',
	CRM_IMPORT_FILE_TOO_LARGE: 'Die Datei ist zu groß (max. 20 MB pro Datei).',
	CRM_IMPORT_INVALID_FILE: 'Ungültige Datei. Bitte laden Sie CSV-Dateien (.csv) hoch.',

	// CRM: Auth
	CRM_ADMIN_REQUIRED: 'Nur Admins und Eigentümer können diese Aktion ausführen.',

	// CRM: Search
	CRM_SEARCH_UNAVAILABLE: 'Die Suche ist vorübergehend nicht verfügbar. Bitte versuchen Sie es in Kürze erneut.',

	// API Keys
	API_KEY_NOT_FOUND: 'Der API-Schlüssel wurde nicht gefunden.',
	API_KEY_NAME_EXISTS: 'Ein API-Schlüssel mit diesem Namen existiert bereits.',
	API_KEY_FORBIDDEN: 'Dieser Endpunkt ist über die API nicht verfügbar.',
	API_KEY_INVALID_SCOPE: 'Dem API-Schlüssel fehlt die erforderliche Berechtigung.',

	// Rate Limiting
	RATE_LIMIT_EXCEEDED: 'Das Anfragelimit wurde überschritten. Bitte versuchen Sie es in Kürze erneut.',
	AUTH_RATE_LIMITED: 'Zu viele fehlgeschlagene Anmeldungen aus Ihrem Netzwerk. Bitte warten Sie eine Minute.',
	AI_COMPLETION_RATE_LIMITED:
		'Sie haben das Limit von 30 KI-Anfragen pro Stunde erreicht. Bitte versuchen Sie es später erneut.',
	AI_CHAT_RATE_LIMITED:
		'Sie haben das Tageslimit von 50 Chat-Nachrichten erreicht. Bitte versuchen Sie es morgen erneut.',
	LEADS_ANALYSIS_RATE_LIMITED:
		'Sie haben das Limit von 10 Firmenanalysen pro Stunde erreicht. Bitte versuchen Sie es später erneut.',
	SEARCH_PLACES_RATE_LIMITED:
		'Sie haben das Limit von 200 Kartensuchen pro Stunde erreicht. Bitte versuchen Sie es später erneut.',

	// Support-Modus
	PLATFORM_ADMIN_REQUIRED: 'Dieser Bereich ist dem Support-Team vorbehalten.',
	SUPPORT_BILLING_CUSTOMER_EXISTS:
		'Diese Organisation hat bereits einen Billing-Customer. Bearbeiten Sie ihn stattdessen.',
	SUPPORT_BILLING_CUSTOMER_NOT_FOUND: 'Diese Organisation hat noch keinen Billing-Customer.',
	SUPPORT_SUBSCRIPTION_EXISTS: 'Diese Organisation hat bereits eine Subscription. Bearbeiten Sie sie stattdessen.',
	SUPPORT_SUBSCRIPTION_NOT_FOUND: 'Die Subscription wurde für diese Organisation nicht gefunden.',
	SUPPORT_STRIPE_ID_TAKEN: 'Diese Stripe-ID ist bereits einer anderen Organisation zugeordnet.',
	SUPPORT_PRICE_NOT_FOUND: 'Dieser Preis existiert nicht im lokalen Katalog.',
	SUPPORT_CUSTOMER_ORG_MISMATCH: 'Billing-Customer und Subscription gehören zu unterschiedlichen Organisationen.',
	SUPPORT_WALLET_NOT_FOUND: 'Für diesen Nutzer existiert kein Guthabenkonto.',
	SUPPORT_MEMBER_NOT_IN_ORG: 'Dieser Nutzer gehört nicht zu der Organisation.',
	SUPPORT_ADDON_STRIPE_MANAGED: 'Dieses Add-on ist über Stripe bezahlt und kann nicht manuell freigeschaltet werden.',
	SUPPORT_MERGE_CANDIDATE_NOT_FOUND: 'Dieses Firmenpaar existiert nicht mehr.',
	SUPPORT_MERGE_CANDIDATE_ALREADY_DECIDED:
		'Dieses Firmenpaar wurde bereits entschieden. Laden Sie die Liste neu, um den aktuellen Stand zu sehen.',
	SUPPORT_SHARED_HOST_NOT_FOUND: 'Diese Domain ist nicht als geteilter Host erfasst.',
	SUPPORT_SHARED_HOST_ALREADY_DECIDED:
		'Diese Domain wurde bereits entschieden. Laden Sie die Liste neu, um den aktuellen Stand zu sehen.',
	SUPPORT_COMPANY_NOT_FOUND: 'Diese Firma existiert nicht mehr im Firmenpool.',

	// Zendesk
	ZENDESK_MESSAGING_NOT_CONFIGURED: 'Der Support-Chat ist derzeit nicht verfügbar.',
};

// HTTP status → generic German message (fallback when no error code)
const STATUS_MESSAGES = {
	400: 'Die Anfrage ist ungültig. Bitte überprüfen Sie Ihre Eingaben.',
	401: 'Sie sind nicht angemeldet. Bitte melden Sie sich erneut an.',
	402: 'Nicht genügend Kapazität für diese Aktion.',
	403: 'Sie haben keine Berechtigung für diese Aktion.',
	404: 'Die angeforderte Ressource wurde nicht gefunden.',
	409: 'Es besteht bereits ein Konflikt mit einem vorhandenen Eintrag.',
	410: 'Diese Ressource ist nicht mehr verfügbar.',
	429: 'Zu viele Anfragen. Bitte warten Sie einen Moment.',
	500: 'Ein interner Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
};

/**
 * German message for a bare backend error code, e.g. the errorCode a failed job carries.
 *
 * @param {string|null|undefined} code
 * @returns {string|null} Null when the code is unknown or missing
 */
export function getErrorMessageForCode(code) {
	return (code && CODE_MESSAGES[code]) || null;
}

/**
 * Returns a German error message for an error object from the backend fetcher.
 * Priority: machine-readable error code → HTTP status fallback → generic message.
 *
 * @param {Error|null} error - Error object with optional .code and .status properties
 * @returns {string} German error message
 */
export function getErrorMessage(error) {
	if (error?.code && CODE_MESSAGES[error.code]) {
		return CODE_MESSAGES[error.code];
	}
	if (error?.status && STATUS_MESSAGES[error.status]) {
		return STATUS_MESSAGES[error.status];
	}
	return 'Ein unbekannter Fehler ist aufgetreten.';
}
